import React, { useState } from 'react';
import emailjs from 'emailjs-com';

import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import { EMAILJS_CONFIG } from '../../config/emailjs';
import './Footer.scss';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    // Prepare email template parameters
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      to_email: 'work.sunnyjonwal@gmail.com', 
      message: formData.message,
      reply_to: formData.email,
      date: new Date().toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric', 
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    };

    // Debug log to check what's being sent
    console.log('Email template parameters:', templateParams);

    // Send email via EmailJS
    emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAILJS_CONFIG.USER_ID
    ).then((response) => {
      console.log('Email sent successfully!', response.status, response.text);
      
      // Also save to Sanity (optional - you can remove this if you only want emails)
      const contact = {
        _type: 'contact',
        name: formData.name,
        email: formData.email,
        message: formData.message,
      };

      return client.create(contact);
    }).then(() => {
      setLoading(false);
      setIsFormSubmitted(true);
      setFormData({ name: '', email: '', message: '' }); // Reset form
    }).catch((error) => {
      console.error('Error sending email:', error);
      setLoading(false);
      alert('Failed to send message. Please try again.');
    });
  };

  return (
    <>
      <h2 className="head-text">Take a coffee & chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <span style={{ fontSize: '2rem', marginRight: '10px' }}>📧</span>
          <div>
            <h4 className="bold-text">Email</h4>
            <a href="mailto:work.sunnyjonwal@gmail.com" className="p-text">work.sunnyjonwal@gmail.com</a>
          </div>
        </div>
        <div className="app__footer-card">
          <span style={{ fontSize: '2rem', marginRight: '10px' }}>📱</span>
          <div>
            <h4 className="bold-text">Phone</h4>
            <a href="tel:+919016161350" className="p-text">+91 9016161350</a>
          </div>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Your Name" name="name" value={name} onChange={handleChangeInput} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">
            Thank you for getting in touch!
          </h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);